var map = {
	"./Madcon - Beggin.jpg": 1918,
	"./Seven nation army.jpg": 6063,
	"./Sexy Bitch.jpg": 1145,
	"./We found love.jpg": 549,
	"./agnieszka już dawno.jpg": 2835,
	"./alive.jpg": 4573,
	"./amerykanskie teledyski.jpg": 6319,
	"./apocalypse-1600776027-tsCmgK4gEU.jpg": 4890,
	"./avatar.jpg": 9623,
	"./avatar2.jpg": 5956,
	"./biala armia.jpg": 1900,
	"./bylas dla mnie wszystkim.jpg": 7572,
	"./cant hold us.jpg": 5924,
	"./danza kuduro.jpg": 4747,
	"./dont worry.jpg": 2024,
	"./headphones.svg": 6485,
	"./headphonesLogo.svg": 688,
	"./hollywood.jpg": 7736,
	"./i belive.jpg": 9689,
	"./ignite-1600419626-nHn4WXY79q.jpg": 5952,
	"./jak aniola glos.jpg": 8645,
	"./kryzysowa narzeczona.jpg": 7034,
	"./królowa łez.jpg": 550,
	"./left.svg": 8430,
	"./locked out of heaven.jpg": 8734,
	"./lubila tanczyc.jpg": 371,
	"./male rzeczy.jpg": 1322,
	"./nad ranem.jpg": 1141,
	"./nie daj się.jpg": 3280,
	"./notAvailable.jpg": 4371,
	"./oczy.jpg": 6716,
	"./ona jest ze snu.jpg": 1079,
	"./ostatnia nocka ale to drill.jpg": 805,
	"./over-my-head-1602154826-mOiKzOJDe6.jpg": 4291,
	"./paranoia.jpg": 8778,
	"./rampampam.jpg": 8231,
	"./right.svg": 7695,
	"./searchMusic.svg": 797,
	"./searchMusicDisc.svg": 4634,
	"./searchMusicMp3.svg": 7103,
	"./sentino x viki gabor.jpg": 1287,
	"./sexualna.jpg": 9452,
	"./shakedown.jpg": 2140,
	"./she doesnt mind.jpg": 2641,
	"./taxi.jpg": 7419,
	"./timber.jpg": 1702,
	"./want-you-feat-sara-skinner-1586956276-s4lOrfrHQj.jpg": 2876,
	"./wehikul czasu.jpg": 4478,
	"./where have u been.jpg": 2554,
	"./zawsze tam gdzie ty.jpg": 3891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;